import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';
import {SORT_ASCENDING} from 'utils/sort';
import './styles.css';

import sortDownButton from 'assets/icons/sort-down-button.svg';
import sortUpButton from 'assets/icons/sort-up-button.svg';

const TableHeader = ({children, className}: any) => (
  <thead className={classNames('header', className)}>
    <tr className="headerRow">{children}</tr>
  </thead>
);

const HeaderItem = ({
  className,
  heading,
  onSort,
  sortDirection,
  children
}: any) => (
  <th className={classNames('item', className)} onClick={onSort}>
    <h4 className={classNames({onSort})}>
      {heading}
      {sortDirection && (
        <img
          className="sortIcon"
          src={sortDirection === SORT_ASCENDING ? sortUpButton : sortDownButton}
          alt="Sort Icon"
        />
      )}
      {children}
    </h4>
  </th>
);

const TableRow = ({children, className, onClick}: any) => (
  <tr
    className={classNames('row', className, {'colab-clickable': onClick})}
    onClick={onClick}>
    {children}
  </tr>
);

class TableBody extends React.Component<any> {
  tbodyRef: any = null;

  constructor(props) {
    super(props);
    this.tbodyRef = React.createRef();
  }

  scrollToTop = () => {
    this.tbodyRef.current.scrollIntoView({block: 'start'});
  };

  render() {
    return (
      <tbody
        ref={this.tbodyRef}
        className={classNames('body', this.props.className)}>
        {this.props.children}
      </tbody>
    );
  }
}

const Table = ({children, className, simpleTable = false}: any) => (
  <table className={classNames('Table', className, {simpleTable: simpleTable})}>
    {children}
  </table>
);

const TableCell = ({children, className, onClick, colSpan}: any) => {
  const classes = classNames(
    'cell',
    {clickableCell: !_.isNil(onClick)},
    className
  );

  return (
    <td onClick={onClick} className={classes} colSpan={colSpan}>
      {children}
    </td>
  );
};

Table.Header = TableHeader;
Table.HeaderItem = HeaderItem;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;

export default Table;
